import {
  ShopCardIcon,
  TransferReceivedIcon,
  TransferSentIcon,
  WayniCreditIcon
} from 'assets/icons'
import TransferRefusedIcon from 'assets/icons/TransferRefusedIcon'

const movType = {
  TRANSFER_SENT: 'Transferencia enviada',
  TRANSFER_RECEIVED: 'Transferencia recibida',
  CREDIT: 'Crédito',
  PURCHASE_WITH_CARD: 'Compra con tarjeta',
  DEBIT: 'Débito',
  PURCHASE_WITH_WITHDRAWAL: 'Compra con extracción',
  ADVANCE: 'Adelanto Wayni',
  CASHBACK: 'Reintegro',
  CASHBACK_CANCELLATION: 'Anulación de reintegro',
  MANUAL_DEBIT: 'Débito manual'
}

export const movementIcon = (movementType) => {
  switch (movementType) {
    case movType.TRANSFER_SENT:
      return <TransferSentIcon height={140} />
    case movType.TRANSFER_RECEIVED:
      return <TransferReceivedIcon height={140} />
    case movType.PURCHASE_WITH_CARD:
      return <ShopCardIcon height={140} />
    case movType.CASHBACK_CANCELLATION:
    case movType.MANUAL_DEBIT:
      return <TransferRefusedIcon height={140} />
    case movType.CREDIT:
    case movType.DEBIT:
    case movType.PURCHASE_WITH_WITHDRAWAL:
    case movType.ADVANCE:
    case movType.CASHBACK:
      return <WayniCreditIcon height={140} />
    default:
      break
  }
}
